import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  UsageStatisticsEventInputFromJSON
} from '@/api'

export interface UsageStatisticsEvent {
  eventType: SystemCode
  counter: number
  inputs: {
    userType: SystemCode
    counter: number
  }[]
}

export function UsageStatisticsEventFromJSON(json: any): UsageStatisticsEvent {
  return {
    eventType: exists(json, 'event_type')
      ? SystemCodeFromJSON(json.event_type)
      : defaultSystemCode(),
    counter: exists(json, 'counter') ? json.counter : 0,
    inputs: exists(json, 'inputs')
      ? json.inputs.map(UsageStatisticsEventInputFromJSON)
      : []
  }
}
